import { useSessionStorage } from '@mantine/hooks';

import { MAINTENANCE_MODE_UNLOCKED_STORAGE_KEY } from '../utils/constants';

export const useMaintenanceModeUnlock = () => {
  const [maintenanceModeUnlocked, setMaintenanceModeUnlocked] =
    useSessionStorage({
      key: MAINTENANCE_MODE_UNLOCKED_STORAGE_KEY,
      defaultValue: false,
      getInitialValueInEffect: false,
      sync: false,
      deserialize: (value) => value === 'true',
    });

  return [maintenanceModeUnlocked, setMaintenanceModeUnlocked] as const;
};
